import React, { useState } from "react";
import { useTheme } from "@emotion/react";
import {
  Backdrop,
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import RadioButtonComponent from "../../components/forms/RadioButtonComponent";
import Form from "../../components/forms/Form";
import InputComponent from "../../components/forms/InputComponent";
import SubmitButton from "../../components/forms/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomSelectComponent } from "../../components/forms/CustomSelectComponent";
import { ORDER_CREATE_RESET } from "../../constants/orderConstants";
import { createOrder } from "../../actions/ordrActions";
import { listProducts } from "../../actions/productActions";

const validationSchema = Yup.object().shape({
  customerName: Yup.string().required("Customer name  is required"),
  customerPhone: Yup.number().required("Customer Phone is required"),
  customerAddress: Yup.string().required("Customer Address is required"),
  discount: Yup.number().required("Discount is required"),
  paid: Yup.boolean().required("Paid is required"),
  shipped: Yup.boolean().required("Shipped is required"),
});

const AddOrder = () => {
  const dispatch = useDispatch();

  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const orderCreate = useSelector((state) => state.orderCreate);
  const { loading, error, success } = orderCreate;

  const productList = useSelector((state) => state.productList);
  const { products, loading: loadingProduct } = productList;

  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (success) {
      dispatch({ type: ORDER_CREATE_RESET });
      navigate("/orders");
      toast("Order created successfully");
    }
    dispatch(listProducts());
  }, [userInfo, dispatch, navigate, success]);

  const [inindivualPrice, setIndividualPrice] = useState([]);
  const [multiInput, setMultiInput] = useState([
    { product: "", qty: 0, price: 0 },
  ]);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const inputList = [...multiInput];
    inputList[index][name] = value;
    setMultiInput(inputList);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (e, index) => {
    e.preventDefault();
    const inputList = [...multiInput];
    inputList.splice(index, 1);
    setMultiInput(inputList);
  };

  // handle click event of the Add button
  const handleAddClick = (e) => {
    e.preventDefault();
    setMultiInput([...multiInput, { product: "", qty: 0, price: 0 }]);
  };

  console.log(inindivualPrice);

  const totalPrice = multiInput.reduce((a, b) => {
    //subtract discout
    return a + parseInt(b.price) * parseInt(b.qty);
  }, 0);

  const handleSubmit = async ({
    customerName,
    customerPhone,
    customerAddress,
    discount,
    paid,
    shipped,
  }) => {
    const order = {
      customerName,
      customerPhone,
      customerAddress,
      orderItems: multiInput,
      discount,
      paid,
      shipped,
      totalPrice,
    };
    if (window.confirm("Editing of an order is not yet supported"))
      dispatch(createOrder(order));
  };

  return (
    <Container>
      {loading ||
        (loadingProduct && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ))}

      <Box
        component="main"
        sx={{
          pt: 10,
          backgroundColor: palette.background.default,
        }}
      >
        {error && <Typography color="error">{error}</Typography>}

        <Typography variant="h5" component="h2">
          Add Order
        </Typography>
        <Container>
          <Form
            initialValues={{
              customerName: "",
              customerPhone: "",
              customerAddress: "",
              discount: 0,
              paid: false,
              shipped: false,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <InputComponent label="customerName" />
              </Grid>
              <Grid item xs={6}>
                <InputComponent label="customerPhone" type={"number"} />
              </Grid>
              <>
                <Grid item xs={12}>
                  <InputComponent label="customerAddress" />
                </Grid>
              </>
              <Grid container spacing={3}>
                {multiInput.map((input, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <FormControl
                      sx={{
                        m: 3,
                      }}
                      fullWidth
                    >
                      <FormControl sx={{ mt: 2, mb: 2 }} fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Select product
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          onChange={(e) => {
                            handleInputChange(e, index);
                            //retieve price of selected product from cart
                            const { price } = products.find(
                              (p) => p._id === e.target.value
                            );
                            const inputList = [...multiInput];
                            inputList[index].price = price;
                            setMultiInput(inputList);
                          }}
                          label={"Select product"}
                          className="form-note-control-selection"
                          name="product"
                          value={input.product}
                        >
                          {products &&
                            products.map((itm) => (
                              <MenuItem selected value={itm._id}>
                                {itm.name || itm.item}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                      <FormControl sx={{ mb: 2, mt: 2 }} fullWidth>
                        <TextField
                          name="qty"
                          label="Qty"
                          value={input.qty}
                          type="number"
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                        />
                      </FormControl>
                      <FormControl sx={{ mb: 2, mt: 2 }} fullWidth>
                        <TextField
                          name="price"
                          label="Price"
                          type="number"
                          value={input.price}
                        />
                      </FormControl>

                      {index > 0 && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={(e) => handleRemoveClick(e, index)}
                        >
                          Remove
                        </Button>
                      )}
                    </FormControl>
                  </Grid>
                ))}

                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => handleAddClick(e)}
                  >
                    Add
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl sx={{ mb: 2, mt: 2 }} fullWidth>
                    <TextField
                      name="totalPrice"
                      label="Total Price"
                      value={totalPrice}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <InputComponent label="discount" type={"number"} />
              </Grid>
              <Grid item xs={6}>
                <RadioButtonComponent label="Paid" name="paid" />
              </Grid>
              <Grid item xs={6}>
                <RadioButtonComponent name={"shipped"} />
              </Grid>
              <Grid item xs={12} sx={{ mb: 1 }}>
                <SubmitButton title={"Add order"} />
              </Grid>
            </Grid>
          </Form>
        </Container>
      </Box>
    </Container>
  );
};

export default AddOrder;
